import React from 'react';
import InfoBlock from '../../../components/marketing/pageSections/faq/InfoBlock';

function BodyFakPage(props) {
    return (
        <>
            <InfoBlock />
        </>
    );
}

export default BodyFakPage;